var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.142,
    height: 30.023,
    viewBox: "0 0 36.142 30.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.02 -2.977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,25.5l6,6,6-6",
    fill: "none",
    stroke: "#f57224",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,18V31.5",
    fill: "none",
    stroke: "#f57224",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.32,27.135A7.5,7.5,0,0,0,27,13.5H25.11A12,12,0,1,0,4.5,24.435",
    fill: "none",
    stroke: "#f57224",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadBlack);
export default __webpack_public_path__ + "static/media/icon-download-black.a4f348b4b559107562f09e3ed3f93c0f.svg";
export { ForwardRef as ReactComponent };